<!-- src/components/Tools/TocNode.vue -->
<template>
  <li class="mb-1" :class="indentClass">
    <div class="d-flex align-items-start">
      <!-- 3) flecha a la izquierda cuando hay hijos -->
      <button
        v-if="hasChildren"
        class="arrow-btn"
        type="button"
        :aria-expanded="isOpen ? 'true' : 'false'"
        :aria-controls="'toc-' + item.id"
        @click="onToggle"
        title="Expand/Collapse"
      >
        <span class="arrow" aria-hidden="true">{{ isOpen ? '▼' : '▶' }}</span>
      </button>
      <span v-else class="leaf-bullet" aria-hidden="true">▪</span>

      <!-- 4) SIEMPRE es hyperlink (título y subtítulos llevan a su anchor) -->
      <a
        :href="item.href"
        class="toc-link flex-grow-1"
        :style="{ textDecoration: 'none' }"
        >
        {{ item.label }}
     </a>

    </div>

    <transition name="collapse">
      <ul v-if="hasChildren && isOpen" class="list-unstyled mt-2" :id="'toc-' + item.id">
        <TocNode
          v-for="child in item.children"
          :key="child.id"
          :item="child"
          :level="level + 1"
          :is-open="isOpenFn(child.id)"
          :toggle="toggle"
          :accordion-first-level="accordionFirstLevel"
          :is-open-fn="isOpenFn"
        />
      </ul>
    </transition>
  </li>
</template>

<script>
export default {
  name: 'TocNode',
  props: {
    item: { type: Object, required: true },
    level: { type: Number, required: true },
    isOpen: { type: Boolean, required: true },
    toggle: { type: Function, required: true },
    accordionFirstLevel: { type: Boolean, default: false },
    isOpenFn: { type: Function, default: null },
  },
  computed: {
    hasChildren() {
      return Array.isArray(this.item.children) && this.item.children.length > 0;
    },
    indentClass() {
      return {
        'ps-0': this.level === 1,
        'ps-3': this.level === 2,
        'ps-4': this.level >= 3,
      };
    },
  },
  methods: {
    onToggle(e) {
      e.preventDefault();
      this.toggle(this.item, this.level);
    },
  },
};
</script>

<style scoped>
.arrow-btn {
  background: transparent;
  border: 0;
  padding: 0 .25rem 0 0;
  line-height: 1;
  cursor: pointer;
}
.arrow {
  display: inline-block;
  width: 1rem;     /* ancho fijo para que no “salte” el layout */
  text-align: center;
  font-size: .95rem;
}
.arrow-placeholder {
  display: inline-block;
  width: 1rem;     /* alinea las filas sin hijos con las que sí tienen flecha */
}
.arrow {
  display: inline-block;
  width: 1rem;
  text-align: center;
  font-size: .75rem;
  color: var(--bs-link-color, #0d6efd); /* mismo azul de los links */
  line-height: 1; 
  position: relative;
  top: 3px;
}

.leaf-bullet {
  display: inline-block;
  width: 0.9rem;          /* mismo ancho que .arrow para alinear texto */
  text-align: center;
  color: var(--bs-link-color, #0d6efd); /* azul como los links */
  font-size: 1.2rem;   
  line-height: 1;
  vertical-align: middle;
  position: relative;
  top: 2px;               /* mismo ajuste que la flecha */
}

</style>
